import { SET_USERS_FILTERS } from '../actions/filters';
const initialState = {
    text: '',
    profile: {},
    company: ''
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_USERS_FILTERS: {
            return {
                ...state,
                text: action.payload.text,
                profile: action.payload.profile,
                enabled: action.payload.enabled,
                company: action.payload.company
            };
        }

        default:
            return state;
    }
};
